import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {}

const module = {
  state: {
    PageConst,

    formData: {},
    previousReportNoList: [],
    nextScheduleList: [],
    pastReportList: [],
  },

  mutations: {
    INIT_STATE (state) {
      state.formData = {}
      state.previousReportNoList = []
      state.nextScheduleList = []
      state.pastReportList = []
    },
  },

  actions: {
    async init ({ state, commit }, payload) {
      commit('INIT_STATE')
      return await ApiUtils.postData({
        data: [
          { api: 'T3110LessonReportService.C50103_getData', input: payload },
        ]
      }).then((data) => {
        state.formData = data[0].output.formData
        state.previousReportNoList = data[0].output.previousReportNoList
        state.nextScheduleList = data[0].output.nextScheduleList
        state.pastReportList = data[0].output.pastReportList
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
